<template>
  <modal class="inventory-modal" :isOpen="isOpen" @close-modal="closeInventoryModal" :showClose="true">
    <template v-slot:content>
        <img class="inventory-modal__theme-logo" :src="themeLogo" alt="Theme Logo"/>
        <div class="inventory-modal__header">
          <img :src="alertIcon" class="inventory-modal__alert-icon" alt="Alert"/>
          <h3 class="inventory-modal__sub-header">Inventory Alert</h3>
        </div>
        <p class="inventory-modal__info mb-1">We do not currently have a <strong>{{ selectedDumpster.size }} Yard Dumpster</strong> available, so we'd like to offer you a <strong>size upgrade</strong> to a <strong>{{ selectedDumpster.sellAsSize }} Dumpster</strong>.
        Your cost, rental period, and included tonnage will remain the same. Any additional weight beyond your included tonnage will result in standard overage fees.
        </p>
        <div class="inventory-modal__images mb-1">
          <div class="inventory-modal__dumpster-image">
             <img v-if="dumpsterImageSize" class="inventory-modal__img" :src="dumpsterImageSize" alt="Dumpster Size"/>
            <p class="inventory-modal__dumpster-size">{{ selectedDumpster.size }} Yard</p>
          </div>
          <div class="arrow">
          <img class="inventory-modal__arrow" :src="arrowIcon" alt="Arrow"/>
          </div>
          <div class="dumpster-image">
             <img v-if="dumpsterImageSellAs" class="inventory-modal__img" :src="dumpsterImageSellAs" alt="Sell As Size"/>
            <p class="inventory-modal__dumpster-size">{{ selectedDumpster.sellAsSize }}</p>
          </div>
        </div>

        <div class="ecom checkbox mb-1">
         <label class="ecom checkbox__label">
          <div v-if="!acknowledged" class="ecom checkbox__fauxbox"></div>
          <img class="ecom checkbox__check-img" v-if="acknowledged" :src="activeCheckbox" alt="Checkbox"/>
           <input type="checkbox" v-model="acknowledged"  class="ecom checkbox__input" />
          <span class="ecom checkbox__text">
           I acknowledge that I will receive a <strong>{{ selectedDumpster.sellAsSize }} Dumpster</strong> for the same agreed-upon costs, rental period, and included tonnage.
          </span>
        </label>
        </div>
        <button :disabled="!acknowledged" @click="onContinueClick" class="btn btn--secondary btn--orange mb-1" type="button">
            <span class="btn__text">Continue</span>
            <img :src="iconArrowRight" alt="Right Arrow">
        </button>

        <p class="inventory-modal__contact">
          Questions or concerns? Give us a call at
         <a :href="`tel:${phoneNumber}`" class="custom-quote__phone">{{phoneNumber}}</a> to discuss additional size options.
        </p>
    </template>
  </modal>
</template>

<script>
import modal from '@/components/Modal.vue'
import config from '@/config'
import { substituteSizeMap } from '@/utilities.js'
const { cdn, phoneNumber } = config

export default {
  props: {
    isOpen: { type: Boolean, required: true },
    selectedDumpster: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    modal
  },
  data () {
    return {
      themeLogo: `${cdn}theme-logo.png`,
      alertIcon: `${cdn}alert.svg`,
      arrowIcon: `${cdn}arrows.svg`,
      activeCheckbox: `${cdn}icons-active-checkbox.svg`,
      iconArrowRight: `${cdn}icons-arrow-right.svg`,
      phoneNumber,
      acknowledged: false
    }
  },
  computed: {
    dumpsterImageSize () {
      const size = this.selectedDumpster.size
      if (!size) return null
      return this.getImageForSize(parseInt(size, 10))
    },
    dumpsterImageSellAs () {
      const sellAsSizeRaw = this.selectedDumpster.sellAsSize
      if (!sellAsSizeRaw) return null
      const size = parseInt(sellAsSizeRaw.replace(/\s*Yard\s*/i, ''), 10)
      return this.getImageForSize(size)
    }
  },
  watch: {
    isOpen (newVal) {
      if (newVal) this.resetModalState()
    }
  },
  methods: {
    onContinueClick () {
      this.$emit('continue', this.acknowledged)
      this.closeInventoryModal()
    },
    closeInventoryModal () {
      this.$emit('close-modal')
    },
    resetModalState () {
      this.acknowledged = false
    },
    getImageForSize (size) {
      const imageSize = Object.entries(substituteSizeMap).find(([key, sizes]) => parseInt(key) === size || sizes.includes(size))?.[0] ?? size
      return `${cdn}${imageSize}-yard-dumpster-card.png`
    }
  }
}
</script>
